module.exports = __webpack_public_path__ + "static/media/mcc-pay.afb6eefc.svg";